import React, { lazy, Suspense } from "react";

const HelmetComponent = lazy(() =>
  import("react-helmet-async").then((m) => ({ default: m.Helmet }))
);

export const Helmet = (props) => (
  <Suspense fallback={null}>
    <HelmetComponent {...props} />
  </Suspense>
);
